import type { FetchBaseQueryError } from "@reduxjs/toolkit/query";

type QueryReturnValue<ResponseType> =
  | { data: ResponseType }
  | { error: FetchBaseQueryError };

// RequestType and ResponseType must be JSON-serializable non-array objects.
export type NetlifyFetchCallback<RequestType, ResponseType> = (
  params: RequestType
) => Promise<QueryReturnValue<ResponseType>>;

// All backend API calls should go through this function. Calls the given API with
// a JSON request payload and returns the JSON response or an error.
export function buildNetlifyCallback<RequestType, ResponseType>(
  api: string
): NetlifyFetchCallback<RequestType, ResponseType> {
  return async (params: RequestType) => {
    const response = await fetch(`/.netlify/functions/${api}`, {
      method: "POST",
      body: JSON.stringify(params),
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      return {
        error: {
          status: response.status,
          data: await response.text(),
        },
      };
    }

    const json = await response.json();
    return { data: json };
  };
}
